<template>
<div class="o-hidden">
    <div class="h-50 bg-near-black flex flex-column items-center mt4-l">
        <div class="h5-l w-100 mt5">
            <img src="../assets/mowpi-clear.png" alt="mowpi" class="w-40-l w-90">
        </div>
        <p class="w-80 w-60-l lh-copy near-white mt5 tj">Mowpi is a project that was born as my thesis back when I was finishing my college degree, and I build it along with Stephanie, my beautiful wife and project partner. The name stands for <strong>Raspberry Pi Web Monitoring</strong> (in spanish) and the basic idea was to build a system capable of collecting <strong>temperature, humidity and voltage</strong> data and feed a web application with it. Using the Raspberry Pi's capabilities, we can obtain sensor data, process it and send it to a centralized database that powers the web application. From there, we are able to see the different locations of our devices, data logs, alerts, and more.</p>
        <p class="w-80 w-60-l lh-copy near-white tj">I have a small project running in my house which is constantly logging temperature and humidity data based on this idea. <br> Feel free to check it out and see the live updates at <a href="https://homepi-mowpi.firebaseapp.com" class="b white">Mowpi</a></p>
        <h4 class="near-white f2-l f3 ttu mt6-l mt5 mb5-l hidden hidden-bottom" v-infocus="'showElement'">Read some of its features below</h4>
        <i class="fas fa-angle-down near-white mb4 f1-l f2 hidden hidden-bottom" v-infocus="'showElement'"></i>
    </div>
    <div class="flex flex-column items-center bg-white bg-texture">
        <img src="../assets/raspberry-pi.png" alt="RaspberryPi" class="w-20-l w-70 mt5">
        <p class="tj near-black w-30-l pa4 b lh-copy hidden hidden-bottom" v-infocus="'showElement'">RaspberryPi is the core technology used for data gathering through connected sensors. It communicates with the web application in order to send the data and make it available for viewing.</p>
        <div class="ph4 mt4-l w-80-l mb5 flex-l items-center-l">
            <div class="fl-l w-40-l mr5-l mt4-l hidden hidden-left" v-infocus="'showElement'">
                <h3 class="near-black tl f2-l f3 tr-l blue ph3">Locations</h3>
                <p class="b near-black tr-l tj ph3 lh-copy fr-l">We are able to dinamically load in a map the different locations of our different devices. This allows us to have an easy place to find each one of them and see the different statuses based on pin colors, which show the status of it. (OK, Warning, Alert). Each pin will take you to a detailed view of the device readings</p>
            </div>
            <img src="../assets/mowpi-home.jpg" alt="mowpi-home" class="w-50-l w-90 fl-l bw2 ba b--light-gray pa1 hidden hidden-right" v-infocus="'showElement'">
        </div>
        <div class="ph4 mt5-l w-80-l mb5 flex-l items-center-l">
            <div class="fl-l w-40-l mr5-l mt4-l hidden hidden-left" v-infocus="'showElement'">
                <h3 class="near-black tl f2-l f3 tr-l blue ph3">Management Dashboard</h3>
                <p class="b near-black tr-l tj ph3 lh-copy fr-l">In this section we are able to create all the information we may need to run our web application. We can add users, locations, devices, unit measures, sensors, etc. We can also set the warning and alert levels through the Formulas window, and set them for a our various sensors</p>
            </div>
            <img src="../assets/mowpi-dashboard-2.jpg" alt="mowpi-dashboard" class="w-50-l w-90 fl-l bw2 ba b--light-gray pa1 hidden hidden-right" v-infocus="'showElement'">
        </div>
        <div class="ph4 mt5-l w-80-l mb5 flex-l items-center-l">
            <div class="fl-l w-40-l mr5-l mt4-l hidden hidden-left" v-infocus="'showElement'">
                <h3 class="near-black tl f2-l f3 tr-l blue ph3">Profiles</h3>
                <p class="near-black tr-l tj ph3 lh-copy fr-l b">We're able to handle profiles to allow permissions for different levels. You can edit your contact information to receive notifications and we even have a nice profile pic for you! </p>
            </div>
            <img src="../assets/mowpi-profile.jpg" alt="mowpi-profile" class="w-50-l w-90 fl-l bw2 ba b--light-gray pa1 hidden hidden-right" v-infocus="'showElement'">
        </div>
        <!-- <img src="../assets/mowpi.png" alt="Mowpi" class="w-10-l w-20"> -->
        <h4 class="near-black f2-l f3 mt6-l mt5">We were even on TV!</h4>
        <p class="silver lh-copy b mb5-l w-40-l w-80">A few days before giving our thesis presentation, we had the chance to do a small video in our university to showcase our project in its initial version. <span class="red f5">(Video in spanish)</span></p>
        <div class="w-40-l w-80 relative" v-if="playVideo === 0">
            <img src="../assets/mowpi-login.jpg" alt="Mowpi" class="pa1 bw2 ba b--black-10 mb3">
            <button class="bw0 pa3 bg-red br2 near-white w-30-l w-40 mb5 pointer bg-animate hover-bg-light-red fw6" @click="play">Play video</button>
        </div>
        <transition name="slide-fade" mode="out-in">
            <iframe v-if="playVideo === 1" class="w-40-l w-90 pa1 bw2 ba b--black-10 mb5" height="450" src="https://www.youtube.com/embed/4A2G_rswNVM?rel=0&amp;showinfo=0&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </transition>
    </div>
</div>
</template>

<script>
export default {
  data: function () {
    return {
      playVideo: 0
    }
  },
  methods: {
    play: function () {
      this.playVideo = 1
    }
  },
  directives: {
    infocus: {
      isLiteral: true,
      inserted: (el, binding, vnode) => {
        let f = () => {
          let rect = el.getBoundingClientRect()
          let inView = (
            rect.width > 0 &&
            rect.height > 0 &&
            rect.top >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
          )
          if (inView) {
            el.classList.add(binding.value)
            window.removeEventListener('scroll', f)
          }
        }
        window.addEventListener('scroll', f)
        f()
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Mowpi.vue